import React from "react";
import { Redirect } from "react-router";

const RedirectToHome = () => {
  document.title = "Create Account or Sign In | Atrable";
  
  return (
    <>
      <Redirect to="/" />
      <div style={{minHeight: "100vh", textAlign: "center"}}>
          <h1>Redirecting to Home</h1>
      </div>
    </>
  );
};

export default RedirectToHome;
